import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";

/**
 * エラーダイアログHook。
 * エラーが発生したときのダイアログを表示する。
 */
export function useErrorDialog() {
    
    const [isError, setIsError] = useState(false);

    function openDialog() {
        setIsError(true);
    }

    function ErrorDialog() {
        return(
            <>
                <Dialog
                    open={isError}
                    onClose={() => setIsError(false)}
                >
                    <DialogTitle>
                        エラー
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            処理を完了できませんでした。
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </>
        );
    }

    return {
        /**
         * 実行するとエラーダイアログが表示される
         */
        openErrorDialog: openDialog,    

        /**
         * ダイアログを表示する画面要素のどこかに配置する
         */
        ErrorDialog: ErrorDialog,
    }

}